import { FormGroup } from '@blueprintjs/core'
import React, { FC } from 'react'
import Select from 'react-select'
import CX from 'classnames'
import { UprightStyle } from '../../../../../types'
import { renderError } from '../Helpers'
import { DepopSpecificValue } from '../types'

interface Props {
  specificName: string
  value: string
  options: DepopSpecificValue[]
  required?: boolean
  error?: any
  onChange: (v: string) => void
}

const styles: UprightStyle = {
  zeroMarginBottom: { marginBottom: 0 }
}

// Goodwill Finds' SpecificInput takes options as a string[] and uses each entry as both the value
// and the label. Depop needs them separated: it stores ids (`black`, `streetwear`) but shows names
// (`Black`, `Streetwear`), and sending the display name back would be rejected.
export const DepopSpecificSelect: FC<Props> = props => {
  const { specificName, value, options, required, error, onChange } = props

  return (
    <FormGroup
      label={specificName}
      labelInfo={required && 'Required'}
      style={styles.zeroMarginBottom}
      className={CX('float-right-formgroup-label', 'nuke-top-margin-loadable-select')}
      helperText={renderError(error)}
    >
      <Select
        value={value}
        options={options.map(opt => ({ value: opt.value, label: opt.displayName || opt.value }))}
        simpleValue
        onChange={v => onChange(v as string)}
        placeholder="Select"
        className="react-select-same-height-as-blueprint"
      />
    </FormGroup>
  )
}
